import * as types from '../actions/types';

const initialState = {
    event: {},
    loading: false,
    eventSearch: {
        value: '',
        isVisible: false,
    },
    shortCode: {
        value: '',
        isVisible: false,
    },
    isEventRemoved: false,
};

export default function (state = initialState, action) {
    const { payload } = action;

    switch (action.type) {
        case types.GET_EVENT_DETAILS_REQUEST:
            return { ...state, loading: true };
        case types.GET_EVENT_DETAILS_SUCCESS:
            return { ...state, loading: false, event: payload };
        case types.UPDATE_EVENT_DETAILS:
            return {
                ...state,
                event: { ...state.event, [action.payload.key]: payload.value },
            };
        case types.CLEAR_EVENT_DETAILS:
            return { ...state, event: {} };
        case types.SET_EVENT_SEARCH_PROPS: {
            return {
                ...state,
                eventSearch: {
                    ...state.eventSearch,
                    ...payload,
                },
            };
        }
        case types.SET_SHORTCODE_SEARCH_PROPS: {
            return {
                ...state,
                shortCode: {
                    ...state.shortCode,
                    ...payload,
                },
            };
        }
        case types.SET_ALL_MARKETS_EVENT_REMOVED: {
            return {
                ...state,
                isEventRemoved: payload,
            };
        }
        default:
            return state;
    }
}
